<template>
  <div>
    <div class="bj">
      <div class="bjContent">
        <div class="bjCont">
          <div class="iconfont icon-close cha" @click="delClick"></div>
          <div class="cont">
            <div class="contHead">面试邀请</div>
            <!-- <div class="contBox">
              <div class="name"><span>*</span>联系人</div>
              <div class="inpBox">
                <a-input placeholder="请输入联系人" v-model="name" />
              </div>
            </div>
            <div class="contBox">
              <div class="name"><span>*</span>联系方式</div>
              <div class="inpBox">
                <a-input placeholder="请输入联系方式" v-model="mobile" />
              </div>
            </div> -->
            <div class="contBox">
              <div class="name"><span>*</span>预约时间</div>
              <div class="inpBox">
                <a-date-picker
                  :locale="zhCN"
                  v-model="start_time"
                  :disabled-date="disabledDate"
                  style="width: 100%"
                  show-time
                  format="YYYY-MM-DD HH:mm"
                  @change="onChange"
                />
              </div>
            </div>
            <!-- <div class="contBox" v-if="!job_id">
              <div class="name"><span>*</span>岗位选择</div>
              <div class="inpBox">
                <a-select
                  show-search
                  placeholder="岗位"
                  option-filter-prop="children"
                  style="width: 100%"
                  v-model="value"
                  :filter-option="filterOption"
                  @change="handleChange"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="item in list"
                    :key="item.id"
                  >
                    {{ item.jobs_name }}
                  </a-select-option>
                </a-select>
              </div>
            </div> -->
            <div class="contBox">
              <div class="name">备注</div>
              <div class="inpBox">
                <a-textarea
                  v-model="remark"
                  placeholder="发布备注~"
                  :auto-size="{ minRows: 3, maxRows: 8 }"
                />
              </div>
            </div>
          </div>
          <div class="gnBox">
            <div class="btn qx" @click="delClick">取消</div>
            <div class="btn" @click="saveclick">确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Form,
  Input,
  Button,
  Upload,
  Icon,
  DatePicker,
} from "ant-design-vue";
import zhCN from "ant-design-vue/es/date-picker/locale/zh_CN";
import "moment/locale/zh-cn"; // 引入 moment 中文包
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-input-password": Input.Password,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-date-picker": DatePicker,
  },
  data() {
    return {
      zhCN,
      mobile: "",
      yanzheng: "",
      name: "",
      password: "",
      newpassword: "",
      remark: "",
      start_time: "",
      value: undefined,
      list: [],
      msShow: false,
    };
  },
  props: ["member_info", "job_id", "to_id" ,"type", "lxType", "odd_id"],
  mounted() {
    this.name = this.member_info.realname;
    this.mobile = this.member_info.phone;
    this.job_id = this.job_id;
    this.odd_id = this.odd_id;
    this.listGet();
    console.log(this.$moment().endOf("day"));
  },
  activated() {},
  methods: {
    disabledDate(current) {
      return current && current < this.$moment().subtract(1, 'days');
    },
    listGet() {
      this.$get("/nozzle/web/company_job", {
        pageNo: -1,
      }).then((res) => {
        console.log(res.data);
        if (res.data) {
          this.list = res.data;
        }
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(value) {
      console.log(value);
      this.job_id = value;
    },
    onChange(date, dateString) {
      console.log("完整的日期和时间:", dateString);
      this.start_time = dateString;
    },
    saveclick() {
      // if (!this.name) {
      //   this.$message.error("请输入用户昵称");
      //   return;
      // }
      // if (!this.mobile) {
      //   this.$message.error("请输入手机账号");
      //   return;
      // }
      let data = {
        // name: this.name,
        // mobile: this.mobile,
        start_time: this.start_time + ":00",
        remark: this.remark,
      };
      if (!this.start_time) {
        this.$message.error("请选择预约时间");
        return;
      }
      if (this.lxType == 1) {
        if (!this.job_id) {
          this.$message.error("请选择岗位");
          return;
        }
        data.job_id = Number(this.job_id);
      }
      if (this.lxType == 2) {
        if (!this.odd_id) {
          this.$message.error("请选择零工");
          return;
        }
        data.odd_id = Number(this.odd_id);
      }
      if (this.type == 2) {
        data.member_id = this.to_id;
      } else {
        data.company_member_id = this.to_id;
      }
      console.log(data);
      
      data = JSON.stringify(data);
      this.$post("/nozzle/web/interview_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("提交成功");
          this.$emit("show", res.data.data);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    delClick() {
      this.$emit("show");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    popupScroll() {
      console.log("popupScroll");
    },
  },
};
</script>
<style lang="less" scoped>
.bjContent {
  display: flex;
  width: 100%;
  justify-content: center;

  .bjCont {
    background-color: #fff;
    width: 600px;
    margin-top: 90px;
    border-radius: 10px;
    position: relative;

    .cha {
      position: absolute;
      cursor: pointer;
      top: 10px;
      font-weight: 600;
      right: 20px;
      color: #9c9c9c;
    }

    .cont {
      padding: 20px 20px 10px;
      .peoImg {
        text-align: center;
        img {
          object-fit: cover;
          overflow: hidden;
          border-radius: 50%;
          width: 70px;
          height: 70px;
          cursor: pointer;
        }
      }

      .contHead {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }

      .contBox {
        padding-top: 20px;
        display: flex;
        .name {
          margin-top: 5px;
          width: 90px;
          text-align: right;
          padding-right: 10px;
          box-sizing: border-box;
          font-size: 12px;
          span {
            color: #f30000;
          }
        }
        .inpBox {
          width: calc(100% - 90px);
          display: flex;
          position: relative;
          .yzmBox {
            position: absolute;
            top: 1px;
            right: 1px;
            width: 80px;
            height: calc(100% - 2px);
            background-color: #ce0808;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 12px;
          }
          .box {
            margin-right: 15px;
            width: calc(33.33% - 10px);
            float: left;
          }
          .box:last-child {
            margin-right: 0;
          }
        }

        .tishi {
          line-height: 150%;
          color: #bfbfbf;
          font-size: 12px;
          margin-top: 5px;
          text-align: justify;
        }

        .upImg {
          margin-top: 10px;

          .text {
            margin-left: 20px;
            font-size: 12px;
          }

          .txt {
            margin-left: 5px;
            font-size: 12px;
            color: #999;
          }

          .imgs {
            display: flex;
            margin-top: 15px;
            flex-wrap: wrap;

            .img {
              width: calc(20% - 12px);
              margin-right: 15px;
              padding-top: calc(20% - 12px);
              position: relative;
              margin-bottom: 15px;
              overflow: unset;

              img {
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 5px;
              }

              .close {
                position: absolute;
                top: -3px;
                right: -3px;
                background-color: #b3b3b3;
                border-radius: 50%;
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                color: #fff;
              }
            }

            .img:nth-child(5n) {
              margin-right: 0;
            }
          }
        }
      }
    }

    .gnBox {
      border-top: 1px solid #d9d9d9;
      padding: 10px 24px;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;

      .btn {
        color: #fff;
        background: #0574dd;
        border: 1px solid #0574dd;
        padding: 5px 15px;
        font-size: 12px;
        border-radius: 5px;
        margin-left: 15px;
        cursor: pointer;
      }

      .qx {
        background: unset;
        border: 1px solid rgb(180, 180, 180);
        color: #666;
      }
    }
  }
}
</style>
